import axios from 'axios'

const timeout: number = 30000

export default class Client {
  request(token, method, uri, data, params) {
    const url = `${process.env.VUE_APP_API_URL}/${uri}`
    const headers = this.headers(token)
    // console.log('Client = ', headers, method, url, data, params)
    return axios({ headers, method, timeout, url, data, params })
  }

  headers(token) {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    }
    return token ? { ...headers, Authorization: token } : headers
  }
}
